<template>
    <div>
        <!-- <div style="display:flex;flex-direction:row;margin-bottom: 20px;">
            <h4>Please select the sales filter you would like to view:</h4>
            <a-select :default-value="displaySalesType" class="mx-3 w-25" @change="handleSalesChange">
                
                <a-select-option value="item">
                    Sales by Item
                </a-select-option>
                <a-select-option value="location">
                    Sales by Location
                </a-select-option>
            </a-select>
        </div> -->
        <div>
             <router-view/>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
    export default {
        name: "SalesLayout",
        computed:{
            ...mapGetters(['getSalesType']),
            displaySalesType(){
                return this.getSalesType
            }
        },
        methods:{
            ...mapActions(['setSalesTypeInfo']),
            handleSalesChange(value){
                if(value === "item"){
                    this.setSalesTypeInfo("item");
                    this.$router.push('/item').catch(()=>{});
                }else if(value === "location"){
                    this.setSalesTypeInfo("location");
                    this.$router.push('/location').catch(()=>{});
                }else if(value === "employement"){
                    this.setSalesTypeInfo("employement");
                    this.$router.push('/employement').catch(()=>{});
                }
            },
        },
    }
</script>

<style  scoped>
.actions{
    display: flex;
    justify-content:space-between;
}
</style>